import { ActiveDescendantKeyManager, Highlightable } from '@angular/cdk/a11y';
import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { ElementRegistryService } from './element.registry.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Injectable()
export class ActiveService<T extends Highlightable> implements OnDestroy {

    public readonly _change$ = new BehaviorSubject<number>(-1);
    public readonly change$: Observable<number> = this._change$.asObservable();

    public readonly items: T[] = [];
    public readonly keyManager = new ActiveDescendantKeyManager<T>(this.items);

    public get activeItem(): T {
        return this.keyManager.activeItem;
    }

    constructor(
        private registry: ElementRegistryService<T>
    ) {

        this.registry.elements$
            .pipe(
                untilDestroyed(this),
                tap(x => {
                    this.items.length = 0;
                    this.items.push(...x);
                })
            )
            .subscribe();

        this.keyManager
            .change
            .pipe(
                untilDestroyed(this),
                tap(x => {
                    this._change$.next(x);
                })
            )
            .subscribe();

    }


    public activate(item: T) {
        this.keyManager.setActiveItem(item);
    }

    public toggle(item: T) {
        if (this.keyManager.activeItem === item) {
            this.deactivate(item);
        } else {
            this.activate(item);
        }
    }

    public deactivate(item: T) {
        if (this.activeItem != item) return;
        this.keyManager.setActiveItem(null);
    }

    ngOnDestroy(): void {
        this.keyManager.destroy();
    }
}